module.exports = __webpack_public_path__ + "img/phone.9202e68a.png";